// Constants.js
export const CON_STATUS_ZERO = "0";
export const CON_STATUS_NONE = "";

export const CON_VALUE_ZERO = 0;
export const CON_EMPTY_VALUE = "";
export const CON_VALUE_ZERO_ST = "0.00";
export const CON_MENUICON_WIDTH = 128;
export const CON_MENUICON_HEIGHT = 128;
export const CON_STATUS_ACTIVE = "A";
export const CON_MAX_FILESIZE_ITEMIMG = 1048576;
export const CON_MAX_FILESIZE_PROMO = 1048576;
export const CON_STATUS_RESTAURANTS = "R";
export const CON_STATUS_KITCHEN = "K";
export const CON_STATUS_PENDING = "P";
export const CON_STATUS_NEW = "N";
export const CON_STATUS_NO = "N";
export const CON_STATUS_RETURN = "R";
export const CON_STATUS_REJECTED = "R";
export const CON_STATUS_RECEIVED = "R";
export const CON_STATUS_DELETED = "D";

export const CON_MENU_TYPE_CODE = "F";

export const CON_IS_CASHIER_YES = "Y";
export const CON_IS_CASHIER_NO = "N";
export const CON_IS_CREDIT_NO = "N";

export const CON_CAT_TYPE_RESTAURANT = "R";
export const CON_CAT_TYPE_POS = "P";

export const CON_MODULECODE = "3";
export const CON_ORDERTYPE_DINEIN = "1";

// Cashier page
export const CON_ADDON_CODE = "0";
export const CON_IS_ADDON = "N";
export const CON_CODENRATE = "0";
export const CON_TAX_PAGE_CODE = "RM";
export const CON_TAX_CODE = "1017";
export const CON_TAX_RATE = "10";
export const CON_TAX_AMOUNT = "60";
export const CON_IS_ADDON_YES = "Y";

export const CON_DELIVERY_STS = "Y";
export const CON_GUEST_REF_CODE = "GREF001";
export const CON_IP_ADDRESS = "192.168.1.1";

export const CON_DEF_WAITING_TIME = 2000;
export const CON_MODULEKEY = "39hkv4eDdZwiQHBDWsepXSFw4v8wTJLj";

// export const GUEST_PAGE_URL =
//   "Guest?compcode=Q1AyMjAwMDAxMDc=&loccode=TVJUTUNMQzAwNTk=&restcode=NA==";
// export const GUEST_CHECKOUT_URL =
//   "GuestCheckout?compcode=Q1AyMjAwMDAxMDc=&loccode=TVJUTUNMQzAwNTk=&restcode=NA==";
